export default "__VITE_PUBLIC_ASSET__5dfcee9e__"